<template>
    <ui-modal name="marketing-integrations-facebook-user-select"
        title="Gerenciar contas do Facebook"
        icon="fal fa-user-circle"
        size="xs">
        <div class="modal">
            <div class="modal-body"> 
                <ui-search-box placeholder="Buscar conta" event="components-ui-marketing-facebook-search" />

                <form class="form">
                    <ui-overlay-load v-if="loader.editingForm && totalAccouts" />

                    <div class="select-facebook-user" ref="scroller">
                        <ui-scroll-facebook name="facebook"
                            tableClass="ui-table"
                            search-event="facebook-search-account"
                            service="facebookAccounts"
                            not-found-icon="fal fa-file-contract"
                            not-found-text="Não existe nenhuma conta cadastrada" />
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <div v-html="textConnectedAccountsComputed" class="actions" />
                <div class="buttons">
                    <ui-button design="lg primary mw-100" @click="addAccount">Conectar nova conta</ui-button>
                </div>
            </div>
        </div>

        <ui-modal-message name="marketing-integrations-facebook-account-now-disconnect"
            service="facebookAccounts"
            text="Deseja continuar ?"
            btn-type="danger"
            title=""
            btn-text="Desconectar" />
    
        <ui-alert name="facebook-account-not-existe-outer-message"
            title="Esta conta possui formulários integrados"
            text="para desconectar crie uma nova conta e transfira o(s) formulario(s)!"
            btn-type="danger"
            btn-text="teste" />
    </ui-modal>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons" 
    import { uiModal } from "@/components/ui/modal"
    import { uiModalMessage } from '@/components/ui/modal'
    import { uiAlert } from '@/components/ui'
    import { uiOverlayLoad, uiSearchBox } from '@/components/ui'
    import uiScrollFacebook from '@/components/ui-facilita/marketing/scroll-facebook'

    import helpers from '@/mixins/helpers'

    export default {
        mixins: [helpers],

        components: {
            uiButton,
            uiModal,
            uiOverlayLoad,
            uiSearchBox,
            uiScrollFacebook,
            uiModalMessage,
            uiAlert,
        },

        data() {
            return {
                loader: {
                    loadModal: false,
                    modalLoadSuccess: false,
                    editingForm: false,
                    users: true,
                },
                qtAccounts: 0
            }
        },

        created() {
            this.$root.$on("disconnected-account", () => {
                this.$root.$emit("datatable-reload-facebook")
			})

            this.$root.$on('total-accounts', (total) => {
                this.qtAccounts = total
            })

            this.$root.$on("components-ui-marketing-facebook-search", (event) => {
                this.searchAccounts(event)
			})
        },

        beforeDestroy() {
            this.$root.$off("disconnected-account")
            this.$root.$off('total-accounts')
            this.$root.$off("components-ui-marketing-facebook-search")
        },

        computed: {
            textConnectedAccountsComputed() {
                return `
                    Existe${this.qtAccounts > 1 ? 'm' : ''}
                    <span class="color-success">${this.qtAccounts} Conta${this.qtAccounts > 1 ? 's' : ''}</span>
                    do Facebook conectada${this.qtAccounts > 1 ? 's' : ''}
                `
            }
        },

        methods: {
            searchAccounts(event) {
                this.$root.$emit('facebook-search-account', event)
            },
            /**
             * Abre em uma nova aba o link para vínculo de uma conta do Facebook
             */
            addAccount() {
                window.open(`https://www.appfacilita.com/wp-json/api/facebook/login?instance=${this.getInstance()}`)
            }

        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>